import { styled } from 'styled-components';

export const ScTournamentBadge = styled.div`
  position: relative;
  display: inline-flex;
  height: 26px;
  padding-inline: 8px;
  column-gap: 4px;
  align-items: center;
  border-radius: 360px;
  color: ${({ theme }) => theme.whiteColor};
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  font-size: 10px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  background-image: linear-gradient(
    90deg,
    rgba(0, 104, 56, 0.9) 0%,
    rgba(37, 211, 102, 0.9) 100%
  );

  &.purple-gradient {
    background-image: linear-gradient(
      90deg,
      rgba(100, 22, 231, 0.9) 0%,
      rgba(133, 77, 235, 0.9) 100%
    );
  }

  &.gold-gradient {
    background-image: linear-gradient(
      102deg,
      rgba(208, 159, 18, 0.9) 13.52%,
      rgba(240, 197, 66, 0.9) 43.06%,
      rgba(241, 198, 65, 0.9) 55.14%,
      rgba(208, 159, 18, 0.9) 82.88%
    );
  }

  &.red-gradient {
    background-image: linear-gradient(
      90deg,
      rgba(222, 0, 0, 0.9) -4.6%,
      rgba(255, 251, 13, 0.9) 108.62%
    );
  }

  &.blue-gradient {
    background-image: linear-gradient(
      271deg,
      rgba(50, 121, 235, 0.9) 0.97%,
      rgba(42, 171, 238, 0.9) 107.14%
    );
  }
  &.orange-gradient {
    background-image: none;
    border: 2px solid transparent;
    background: linear-gradient(${({ theme }) => theme.blackColor}, ${({ theme }) => theme.blackColor}) padding-box,
    linear-gradient(to bottom, #FFD800, #FF9E01) border-box;
    
    .label {
      color: #FFBE01;
    }
  }
  &.pink-gradient {
    background-image: linear-gradient(
      120deg, 
      #CA486A 34.84%, 
      #B418E2 103.6%
    );
  }
  
  & > .decor {
    position: absolute;

    &.coin-right {
      bottom: -5px;
      right: 0;
    }

    &.coin-left {
      top: -4px;
      left: -4px;
    }

    &.star-right {
      bottom: -3px;
      right: -4px;
    }

    &.star-left {
      top: -3px;
      left: -2px;
    }
  }
`;
